$(document).ready(function() {
    $('.subscription-bundles .bundles .btn').on('click', function(e) {
        e.preventDefault();
        const id = $(this).data('id');
        const selling_plan = $(this).data('selling-plan');
        const hasFreeProducts = $(this).data('free-products');

        const addItemsToCart = (formData) => {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if (response.ok) {
                    window.location.href = window.Shopify.routes.root + 'cart';
                }
            })
            .catch((e) => {
                // do nothing
            });
        }

        if (hasFreeProducts == true) {
            const $freeProductsModal = $(`.free-products-modal[data-bundle-id="${id}"]`);
            const $freeProductsSelect = $(`.free-products-modal[data-bundle-id="${id}"] select.free-products__variants`);
            const $freeProductsModalButton = $(`.free-products-modal[data-bundle-id="${id}"] button.free-products-submit`)

            $freeProductsModal.addClass('is-active');
            document.documentElement.classList.add('modal-is-active');

            function closeModal($el) {
                $el.classList.remove('is-active');
                document.documentElement.classList.remove('modal-is-active');
            }

            function closeAllModals() {
                (document.querySelectorAll('.modal') || []).forEach(($modal) => {
                    closeModal($modal);
                });
            }

            // Add a click event on various child elements to close the parent modal
            (document.querySelectorAll('.modal-background, .modal-close, .btn.close') || []).forEach(($close) => {
                const $target = $close.closest('.modal');

                $close.addEventListener('click', () => {
                    closeModal($target);
                });
            });

            // Add a keyboard event to close all modals
            document.addEventListener('keydown', (event) => {
                if (event.code === 'Escape') {
                    closeAllModals();
                }
            });

            // Remove validation class, if set
            $freeProductsSelect.on('change', function() {
                $(this)[0].classList.remove('input--error');
            });

            $freeProductsModalButton.on('click', function(e) {
                if ((id != null && typeof id != 'undefined') && (selling_plan != null && typeof selling_plan != 'undefined')) {
                    const formData = {
                        'items': [{
                            id,
                            selling_plan,
                            'quantity': 1
                        }]
                    };

                    if ($freeProductsSelect.length > 0) {
                        let validationError = false;

                        for (let i = 0; i < $freeProductsSelect.length; i++) {
                            let $vid = parseInt($freeProductsSelect[i].value);
                            if ($vid != null && typeof $vid != 'undefined' && !isNaN($vid)) {
                                formData.items.push({id: $vid});
                            } else {
                                $freeProductsSelect[i].classList.add('input--error');
                                validationError = true;
                            }
                        }
                        // Send if no validation errors
                        if (!validationError) {
                            addItemsToCart(formData);
                        }
                    }
                }
            });
        } else {

            if ((id != null && typeof id != 'undefined') &&
                (selling_plan != null && typeof selling_plan != 'undefined')) {

                const formData = {
                    'items': [{
                        id,
                        selling_plan,
                        'quantity': 1
                    }]
                };

                addItemsToCart(formData);
            }
        }
    });
});